import { lazy, Suspense, Fragment, useState, useEffect, useCallback } from "react";
import axios from "axios";
import "./css/catalogo.css";
import Container from "react-bootstrap/Container";
//import DetalleModelos from "./DetalleVehiculos";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import { Server } from "../../constants";

const DetalleModelos = lazy(() => import("./DetalleVehiculos"));
function CatalogoVehiculos({ datos }) {
    const [activeModel, setActiveModel] = useState(null);
    const [token, setToken] = useState("");
    const [rowsEmpresas, setRowsEmpresas] = useState([]);
    const [tabKey, setTabKey] = useState('AUTOS');
    const renderAccordions = useCallback((cars) => {
        return cars.map((car, index) => (
            <Accordion.Collapse key={index} eventKey={car.MOD_CODIGO}>
                <Card.Body className="d-none d-sm-block">
                    {activeModel === car.MOD_CODIGO && (
                        <Suspense fallback={<div>Cargando...</div>}>
                            <DetalleModelos modelo={car} token={token} />
                        </Suspense>
                    )}
                </Card.Body>
            </Accordion.Collapse>
        ));
    }, [token, activeModel]);

    const renderCarItems = useCallback((cars, fullData) => {
        return cars.map((car, index) => (
            <Col key={car.MOD_CODIGO} xs={9} sm={6} md={5} lg={2} className="carta-vehiculo px-0 text-center mb-4">
                <Accordion.Toggle as={Button} variant="link" eventKey={car.MOD_CODIGO}>
                    <img
                        src={car.MOD_FOTO_PRINCIPAL}
                        alt={`Hyundai ${car.MOD_NOMBRE}`}
                        loading="lazy"
                        decoding="async"
                        width="300"
                        height="180"
                        className="img-accordion-catalogo img-fluid"
                        style={{ width: "100%", height: "auto" }}
                        onClick={() => {
                            handleModeloClick(car.MOD_CODIGO, fullData);
                            setActiveModel(car.MOD_CODIGO);
                        }
                        }
                    />
                    <h3 className="nombre-modelo" id={car.MOD_CODIGO}>
                        {car.MOD_NOMBRE}
                    </h3>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={car.MOD_CODIGO}>
                    <Card.Body className="d-block d-sm-none">
                        {activeModel === car.MOD_CODIGO && (
                            <Suspense fallback={<div>Cargando...</div>}>
                                <DetalleModelos modelo={car} token={token} />
                            </Suspense>
                        )}
                    </Card.Body>
                </Accordion.Collapse>
            </Col>
        ));
    }, [token, activeModel]);

    const renderCarRows = useCallback((autos, fullData) => {
        return autos.map((car, index) => (
            <Col key={index}>
                <Row className="cards-row">{renderCarItems(car, fullData)}</Row>
                <Row>
                    <Col md={12} className="px-0">
                        {renderAccordions(car)}
                    </Col>
                </Row>
            </Col>
        ));
    }, [renderAccordions, renderCarItems]);

    const handleModeloClick = (modelo, fullData) => {
        fullData.forEach((row) => {
            row.MOD_LISTA_AUTOS.forEach((autoList) => {
                autoList.forEach((auto) => {
                    document.getElementById(auto.MOD_CODIGO).className = "nombre-modelo";
                });
            });
        });
        const modeloElement = document.getElementById(modelo);
        modeloElement.classList.toggle("nombre-modelo-active");
    };

    const handleSelect = (key) => {
        setTabKey(key);
    };

    const createEmpresaRows = useCallback((data) => {
        return data.map((row, index) => (
            <Tab key={index} eventKey={row.MOD_TIPO_MODELO} title={row.MOD_TIPO_MODELO}>
                <Container className="my-4 px-0">
                    <Row className="row-custom">
                        <Col className="px-0">
                            <Accordion defaultActiveKey={row.MOD_TIPO_MODELO}>
                                <Card>
                                    <Card.Header className="contenedor-cartas-vehiculos my-3 px-md-3">
                                        {renderCarRows(row.MOD_LISTA_AUTOS, data)}
                                    </Card.Header>
                                </Card>
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
            </Tab>
        ));
    }, [renderCarRows]);

    const fetchNoticiasMarcaEmpresa = useCallback(async () => {
        try {
            const { data } = await axios.get(`${Server}/api/vehiculos/getListAutosWeb`);
            setRowsEmpresas(createEmpresaRows(data.data));
        } catch (error) {
            console.error("Error fetching data", error);
        }
    }, [createEmpresaRows]);

    useEffect(() => {
        const procedencia = datos.match.params.procedencia;
        const tokens = {
            ytb: "4d4168d927",
            pro: "acbf99324b",
            fb: "f574989ebc",
            ggdn: "b512562127",
            gsearch: "8bd4176c22",
            default: "981ca38f59",
        };
        const token_var = sessionStorage.getItem("tk") || tokens[procedencia] || tokens.default;
        setToken(token_var);
        sessionStorage.setItem("tk", token_var);
        fetchNoticiasMarcaEmpresa();
    }, [datos.match.params.procedencia, fetchNoticiasMarcaEmpresa]);

    return (
        <Fragment >
            <Container className="catalogo-modelos mb-5" style={{ minHeight: "416px", overflow: "hidden" }}>
                <Row>
                    <Col md={12} className="navtabs-accordion-container px-0">
                        <Tabs justify defaultActiveKey={tabKey} onSelect={handleSelect}>
                            {rowsEmpresas}
                        </Tabs>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
export default CatalogoVehiculos;